import useUrlLocationOperationsStore from '~/stores/useUrlLocationOperationsStore';
import { passStoreThroughComposableFactory } from '~/utils/passStoreThroughComposableFactory';

export const useUrlLocationOperations = () => passStoreThroughComposableFactory(useUrlLocationOperationsStore());

export default useUrlLocationOperations;
